import { render, staticRenderFns } from "./TarjetaCliente.vue?vue&type=template&id=343ebe84&scoped=true&"
import script from "./TarjetaCliente.vue?vue&type=script&lang=js&"
export * from "./TarjetaCliente.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaCliente.vue?vue&type=style&index=0&id=343ebe84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ebe84",
  null
  
)

export default component.exports